<template>
  <div style="height:100%">
    <iframe :src="link" style="width:100%;height:100%;border:0"></iframe>
  </div>
</template>

<script>
export default {
  computed: {
    link () {
      return `http://report.choicelink.cn:8095/WebReport/ReportServer?reportlet=cailian/满意度调查表/项目评委信息.cpt&UserName=${this.$store.state.session.user.name}`
    }
  }
}
</script>
<style lang="less" scoped>

</style>